import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Loading from '../common/Loading.js';
import ErrorMessage from '../common/ErrorMessage.js';
import AsyncTypeahead from 'react-bootstrap-typeahead/lib/AsyncTypeahead.react'; 
import LocationService from '../../services/locationService';
import ArtistService from '../../services/artistService';
import * as textUtils from '../../utils/textUtils';
import * as browserCheck from '../../utils/browserCheck.js';
import ToastrService from '../../services/toastrService';
import pull from 'lodash/pull';
import MaterialDropDown from '../common/MaterialDropDown.js';

class EditGetToKnowMe extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.updateProfileField = this.updateProfileField.bind(this);
        this.locationSearch = this.locationSearch.bind(this);
        this.locationSelected = this.locationSelected.bind(this);
        this.getLocationSelected = this.getLocationSelected.bind(this);
        this.updateLocation = this.updateLocation.bind(this);
        this.influencesSearch = this.influencesSearch.bind(this);
        this.influencesSelected = this.influencesSelected.bind(this); 
        this.getInfluencesSelected = this.getInfluencesSelected.bind(this);
        this.initialise = this.initialise.bind(this);
        this.save = this.save.bind(this);
        this.state = {
            profile: this.props.profile,
            country: this.props.profile.Country,
            locationTypeaheadLoading: false,
            locationTypeaheadOptions: [],
            influencesTypeaheadLoading: false,
            influencesTpeaheadOptions: [],
            loadingBio: false,
            bio: '',
            loadingAssociations: false,
            associations : []
        };
     }

     componentWillMount() {
        if(!this.props.countries.length) {
            this.props.actions.getCountries();
        }
        this.initialise();
     }

    componentDidMount() {  
        if(browserCheck.canUseDom()) {                
            window.componentHandler.upgradeDom();      
            const {getmdlSelect} = require('../../scripts/getmdl-select.js');
            getmdlSelect.init('#frmCreateProfile .getmdl-select');    
            $('#Country').parent().addClass('is-dirty');  
            $('#Bio').parent().addClass('is-dirty');    
        }
    }

    componentWillUpdate(nextProps) {
        if (nextProps.profile.ID !== this.props.profile.ID) {
            this.setState({
                profile: nextProps.profile,
                bio: '',
                associations: []
            }, this.initialise);
        }
        else if (nextProps.createProfileError !== this.props.createProfileError) {
            this.setState({ error: nextProps.createProfileError });
        }
    }

    initialise() {
        this.setState({ loadingBio: true, loadingAssociations: true });
        this.props.actions.getBio(this.state.profile.ID)
            .then(bio => {
                this.setState({ loadingBio: false, bio });
            })
            .catch(error => this.setState({ loadingBio: false }));
        this.props.actions.getAssociations(this.state.profile.ID)
            .then(associations => {
                this.setState({ loadingAssociations: false, associations });
            })
            .catch(error => this.setState({ loadingAssociations: false }));
    }

    updateProfileField(event) {
        const name = event.target.name;
        const value = event.target.className === 'mdl-menu__item' ? event.target.innerText : event.target.value;
        const profile = {...this.state.profile};
        profile[name] = value;
        this.setState({ profile });
    }

    locationSearch(query) {
        this.setState({locationTypeaheadLoading: true});
        const country = this.props.countries.find(c => c.Name === this.state.country);
        LocationService.searchLocation(country.Code, true, false, query)
        .then(items => {
            this.setState({
                locationTypeaheadLoading: false,
                locationTypeaheadOptions: items
            });
        } );
    }

    locationSelected(items) {
        this.updateLocation(items);    
    }

    getLocationSelected() {
        //return the selected location in typeahead format
        const profile = this.state.profile;
        const items = [];
        if(profile.City) {
            const label = profile.LocationDesc ? profile.LocationDesc : textUtils.formatLocation(profile.City, profile.Region, '');
            items.push({
                label: label,
                value: label,
                city: profile.City,
                region: profile.Region,
                country: profile.Country,
                longitude: profile.Longitude,
                latitude: profile.Latitude
            });
        }
        return items;
    }

    updateLocation(location) {
        const profile = {...this.state.profile};
        if(location && location.length) {
            profile['City'] = location[0].city;
            profile['Region'] = location[0].region;
            profile['Country'] = location[0].country;
            profile['Latitude'] = location[0].latitude;
            profile['Longitude'] = location[0].longitude;    
            profile['LocationDesc'] = location[0].label;        
        }
        else {
            profile['City'] = '';
            profile['Region'] = '';
            profile['Country'] = '';
            profile['Latitude'] = '';
            profile['Longitude'] = '';
            profile['LocationDesc'] = ''; 
        }
        this.setState({ profile });
    }

    influencesSearch(query) {
        this.setState({influencesTypeaheadLoading: true});
        ArtistService.getAssociations(query)
            .then(items => {
                this.setState({
                    influencesTypeaheadLoading: false,
                    influencesTypeaheadOptions: items
                });
            });
    }

    influencesSelected(items) {     
        //send to the server and then push to array
        if(items.length > 8) {
            this.setState({ error: 'Sorry, you can\'t select more than 8 influences' });
        }
        else {
            const toastrService = new ToastrService();
            if(items.length < this.state.associations.length) {
                //we've removed 1, remove it from the server and then from state
                const removedAssociation = this.state.associations.find(a => !items.find(i => i.AssociationID === a.AssociationID));
                this.props.actions.deleteAssociation(this.state.profile.ID, removedAssociation.AssociationID)
                    .then(result => {
                        let associations = [...this.state.associations];
                        pull(associations, removedAssociation);
                        this.setState({ associations });
                        toastrService.showSuccess('', `${removedAssociation.AssociationName} has been removed as ${this.state.profile.RoleType === 'Fan' ? 'a favourite artist': 'an influence'} on your profile`);
                    });
            }
            else {
                //we've added 1, find the item with no ID
                const item = items.find(i => !i.AssociationID);
                const newAssociation = { 
                    roleID: this.state.profile.ID,
                    sourceSystem: item.sourcesystem,
                    sourceSystemID: item.id,
                    associationName: item.name
                };
                this.props.actions.addAssociation(this.state.profile.ID, newAssociation)
                    .then(association => {
                        let associations = [...this.state.associations];
                        associations.push(association);
                        this.setState({ associations });
                        toastrService.showSuccess('', `${association.AssociationName} has been added as ${this.state.profile.RoleType === 'Fan' ? 'a favourite artist': 'an influence'} on your profile`);
                    });
            }
        }
    }

    getInfluencesSelected() {
        //return the selected influences in typeahead format
        const items = this.state.associations.map(a => Object.assign({}, a, {
                label: a.AssociationName,
                value: a.AssociationID
           })
        );
        return items;
    }

    save(event) {
        event.preventDefault();
        //just save the bio and location
        this.props.actions.updateProfile(this.state.profile.ID, this.state.profile, false)
            .then(profile => {
                if (profile) {
                    this.props.actions.createBio(this.state.profile.ID, this.state.bio)
                        .then(bio => {
                            this.setState({ bio, profile });
                            const toastrService = new ToastrService();
                            toastrService.showSuccess('', 'The changes have been saved successfully');
                        })
                        .catch(error => this.setState({ error: 'Sorry, something went wrong, unable to save bio' }));
                }
            })
            .catch(error => this.setState({ error: 'Sorry, something went wrong, unable to save changes' }));
    }

    render() {
        return (
            <form id="frmGetToKnowMe" className="form-regular form-tightfields" onSubmit={this.save}>
                <React.Fragment>
                    {
                        this.state.loadingBio || this.state.loadingAssociations ? <div style={{padding:'0 0 20px 0'}}><Loading /></div> : null
                    }                    
                    <ErrorMessage error={this.state.error} onClose={() => this.setState({ error: null })} />
                    <div className="row">
                        <div className="col-md-6">
                            <MaterialDropDown
                                name="Country" 
                                value={this.state.country} 
                                required 
                                data={this.props.countries} 
                                onClick={(e) => this.setState({ country: e.target.innerText })}
                                itemTextFunc={(country) => country.Name}
                                itemValueFunc={(country) => country.Code}
                                className="getmdl-select__fullwidth getmdl-select--limited placeholder" />
                        </div>
                        <div className="col-md-6">
                            <div id="divLocation" className={`mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-block is-dirty ${!this.state.country ? 'is-disabled' : ''}`} >
                                <AsyncTypeahead id="Location" placeholder="City Name" minLength={3} isLoading={this.state.locationTypeaheadLoading} onSearch={this.locationSearch} onChange={this.locationSelected} options={this.state.locationTypeaheadOptions} selected={this.getLocationSelected()} disabled={!this.state.country} />
                                <label className="mdl-textfield__label" htmlFor="Location">Location</label>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
                {
                    ArtistService.showInfluences(this.state.profile.RoleType) ?
                        <div id="divBrowseInfluences">
                            <div className="form-group form-multiselect">
                                <div className="materialize-autocomplete mdl-textfield--floating-label mdl-block is-dirty" style={{ paddingBottom: 0 }}>
                                    <AsyncTypeahead id="Influences" multiple placeholder={this.props.profile.RoleType == 'Producer' ? 'Producer Name' : 'Artist Name'} minLength={3} isLoading={this.state.influencesTypeaheadLoading} onSearch={this.influencesSearch} onChange={this.influencesSelected} options={this.state.influencesTypeaheadOptions} selected={this.getInfluencesSelected()} />
                                    <label className="mdl-textfield__label" htmlFor="Influences">{this.props.profile.RoleType === 'Fan' ? 'Favourite Artists' : 'Influences'}</label>
                                </div>
                                <p className="help-block">e.g. {this.props.profile.RoleType === 'Producer' ? 'Timbaland, Dr Dre' : 'The Beatles, Kanye West'}, etc - add up to 8</p>
                            </div>
                        </div>
                        : null
                }
                <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-block is-dirty" style={{width:'100%'}}>
                    <textarea className="mdl-textfield__input" cols="55" id="Bio" name="Text" rows="6" value={this.state.bio} onChange={(event) => this.setState({ bio: event.target.value })} />                            
                    <label className="mdl-textfield__label" htmlFor="Bio">Bio:</label>
                </div>
                <div className="form-group" style={{textAlign: 'center'}}>
                    <input type="submit" value="Save" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent mdl-button--wide" />
                </div>
            </form>            
        );
    }
}

EditGetToKnowMe.propTypes = {
    profile: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    countries: PropTypes.array,
    createProfileError: PropTypes.string
};

export default EditGetToKnowMe;